import { action, observable, runInAction } from 'mobx';

import notificationsClient from '../clients/NotificationsClient';

export default class NotificationsStore {
  @observable unseenCount: number = 0;

  @action
  acknowledgeUnseenNotificationsCount() {
    this.unseenCount = 0;
  }

  countUnseenNotifications() {
    (async () => {
      try {
        const { count } = await notificationsClient.countUnseenNotifications();
        runInAction(() => {
          this.unseenCount = count;
        });
      } catch (e) {
        // ignore failed count. we'll retry later
        // tslint:disable-next-line:no-console
        console.error(e);
      }
    })();
  }
}
